/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberManagerRejectResponse } from "./MemberManagerRejectResponse";

export type MemberManagerRejectResponseApiRespoonse = {
  data?: MemberManagerRejectResponse;
  status?: MemberManagerRejectResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace MemberManagerRejectResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
